import { render } from "./BasePictureAvatar.vue?vue&type=template&id=0f51a82b"
import script from "./BasePictureAvatar.vue?vue&type=script&lang=js"
export * from "./BasePictureAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__